<template>
  <div v-if="is_visible" class="fixed flex items-center justify-center z-50 papsi-modal-overlay">
    <div :class="['bg-white rounded p-5 md:p-8 xl:rounded-xl xl:p-8 relative', width]" >
      
      <img
        v-if="closable"
        class="absolute w-5 h-5 lg:w-8 lg:h-8 cursor-pointer bg-white p-1 lg:p-2 rounded-full hover:bg-gray-100 z-10 close"
        src="@/assets/icons/close_icon.svg"
        @click.self="closeModal"
      />

      <div class="modal-body overflow-y-auto pr-2" style="max-height: calc(80vh);">
        <slot></slot>
      </div>
      
    </div>
  </div>
</template>


<script>
// import mixin from "@/mixins/controls.js";

export default {
  name: "v-modal",
  // mixins: [mixin],
  props: {
    is_visible: {
      type: Boolean,
      required: true,
    },
    closable: {
      type: Boolean,
      default: true,
      required: false,
    },
    width: {
      type: String,
      default: "w-2/3",
    },
    blur: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.papsi-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.edit-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px); /* adjust blur strength */
  -webkit-backdrop-filter: blur(6px);
}

.close {
    top: 0.45rem;
    right: 0.45rem;
}


</style>